import { Center } from '@mantine/core';
import { useNetwork } from '@mantine/hooks';
import React, { HtmlHTMLAttributes, useEffect, useState } from 'react';
import { DefaultIllustration, OfflineIllustration } from '@/components';
import storage from '@/utils/storage';

type MainLayoutProps = HtmlHTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
  showOfflinePopup?: boolean;
  isPrelogin?: boolean;
};
export const OfflineContainer = ({ children, showOfflinePopup, isPrelogin }: MainLayoutProps) => {
  const isServerOffline = storage.getItem('IS_SERVER_OFFLINE');
  const networkStatus = useNetwork();
  const isServerTimeout = storage.getItem('IS_SERVER_TIMEOUT');
  const isNoInternet = !networkStatus.online;

  const errorIllustraion = {
    IS_SERVER_OFFLINE: 'SomethingWentWrong',
    IS_SERVER_TIMEOUT: 'Timeout',
    IS_NO_INTERNET: 'NoInternet',
  };
  const [isOffline, setIsOffline] = useState(false);

  const getIllustration = () => {
    if (isNoInternet) {
      return errorIllustraion.IS_NO_INTERNET;
    }
    if (isServerOffline) {
      return errorIllustraion.IS_SERVER_OFFLINE;
    }
    if (isServerTimeout) {
      return errorIllustraion.IS_SERVER_TIMEOUT;
    }
    return errorIllustraion.IS_SERVER_OFFLINE;
  };

  useEffect(() => {
    switch (true) {
      case isNoInternet:
        setIsOffline(true);
        break;
      case isServerOffline:
        setIsOffline(true);
        break;
      case isServerTimeout:
        setIsOffline(true);
        break;

      default:
        setIsOffline(false);
        break;
    }
  }, [isNoInternet, isServerOffline, isServerTimeout]);

  return (
    <>
      {isOffline && showOfflinePopup ? (
        <Center h="calc(100vh - 100px)">
          {isPrelogin ? (
            <OfflineIllustration name={getIllustration()} />
          ) : (
            <DefaultIllustration name={getIllustration()} />
          )}
        </Center>
      ) : (
        children
      )}
    </>
  );
};
